import { useEffect, useState } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import BoardCard from '../../components/BoardCard';
import { useAccount } from '../../contexts/Account';
import eventBus, { eventBusValues } from './../../eventBus';
import calendar from '../../icons/calendar.svg';
import { getAdvisorQueryParams } from '../../utils/queryParams';

const MyBoards = () => {
  const { accountDetails, isFreeTrial, isFreemium } = useAccount();
  const [boardsData, setBoardsData] = useState(
    accountDetails.boards.memberBoards
  );

  function goToRoute(route) {
    window.open(
      `${route}?${getAdvisorQueryParams({
        accountDetails,
        isFreeTrial,
        isFreemium,
      })}`
    );
  }

  useEffect(() => {
    eventBus.on(eventBusValues.advisorAnsweredInvitationV2, (board) => {
      setBoardsData([...boardsData, board]);
    });
    return () => {
      eventBus.remove(eventBusValues.advisorAnsweredInvitationV2);
    };
  }, []);

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        borderRadius: '16px',
        backgroundColor: '#fff',
        marginTop: '20px',
        boxShadow: 'none',
      }}
      id="my-boards-tile"
    >
      <Typography
        sx={{
          fontSize: '20px',
          font: 'Poppins',
          fontWeight: 600,
          lineHeight: '26px',
          marginBottom: '0px',
          color: '#001030',
        }}
      >
        My Boards
      </Typography>
      <Typography
        sx={{
          fontWeight: '400',
          fontSize: 14,
          color: '#4D586E',
          fontStyle: 'italic',
          marginTop: '5px',
        }}
      >
        Joining a variety of advisory boards allows you to share your ideas
        across diverse companies and expand your exposure for professional
        opportunities and valuable benefits. AdvisoryCloud makes sharing your
        ideas across your portfolio of boards easy, exciting and rewarding.
      </Typography>

      <Grid container spacing={3}>
        {accountDetails.boards.memberBoards.length > 0 ? (
          accountDetails.boards.memberBoards.map((board, index) => (
            <Grid item xs={12} sm={6} md={3} sx={{ width: '100%' }} key={index}>
              <BoardCard board={board} displayPillsFlag height="340px" />
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={3} sx={{ width: '100%' }} key="join">
            <BoardCard
              board={{
                companyName: 'Join Advisory Boards!',
                headline:
                  'Our platform makes it easy and rewarding to be on boards built by 100s of organizations on AdvisoryCloud.',
              }}
              headlineMarginBottom="40px"
              height="340px"
            />
          </Grid>
        )}
        <Grid item xxs={12} xs={6} sm={4} md={3}>
          <BoardCard
            board={{
              companyName: 'Start Your Own Board',
              headline:
                'Included with your membership is the ability to start your own advisory board for a company, team or personal side project.',
            }}
            buttonText="Get Started"
            hideMemberSince
            fullWidth
            height="340px"
            staticTile
            customImage={calendar}
            headlineMarginBottom="40px"
            onClick={() =>
              goToRoute(
                'https://register.advisorycloud.com/babs/add-your-advisory-board/'
              )
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MyBoards;
